import clsx from 'clsx';
import type { HTMLAttributes } from 'react';

export function Card({
  className,
  variant = 'default',
  ...rest
}: HTMLAttributes<HTMLDivElement> & { variant?: 'default' | 'gold' }) {
  return (
    <div
      className={clsx(
        'rounded-lg border bg-bg-1 transition-colors duration-base',
        variant === 'gold'
          ? 'border-border-accent shadow-gold'
          : 'border-border shadow-md',
        className,
      )}
      {...rest}
    />
  );
}
